import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import BackArrow from 'assets/back-arrow.svg';
import ThemeStore from 'stories/ThemeStore';
import { useSmartLink } from '../../../hooks/useSmartLink';
import { Map } from './Map';
import { useParams } from 'react-router';
import Polygon from '../../../assets/Polygon.svg';
import PolygonActive from '../../../assets/PolygonActive.svg';
import PeriodRangeDropdown from '../PeriodRangeDropdown/PeriodRangeDropdown';
import { LineChart } from './LineChart';
import { getRandomColor } from 'components/Analytics/utils';
import { ProgressSpinner } from 'primereact/progressspinner';

interface SmartLinkAnalyticsProps {


}

export const SmartLinkAnalytics: React.FC<SmartLinkAnalyticsProps> = () => {
    const theme = ThemeStore.activeTheme;
    const { loading, error, data: allData, createSmartLink, updateSmartLink, getAnalyticsOverview, dataAnl, getAnalyticsTimeseries, getAnalyticsCountries } = useSmartLink();
    const [selectedData, setSelectedData] = useState<string>("Last 7 Days");

    const params = useParams();
    const id = params.id;
    const data = allData?.filter((value: any) => value.id == id)[0];
    interface AnalyticsData {
        clicks: number;
        views: number;
        top_country: string;
        top_city: string;
    }

    const [newData, setNewData] = useState<AnalyticsData | null>(null);
    const [open, setOpen] = useState(false)
    interface Timeseries {
        date: string;
        month: string;
        views: number;
        clicks: number;
        conversions: number;
        platform_id: number;
        plays: number;
    }


    const [timeseries, setTimeseries] = useState<Timeseries[]>();
    const [CountriesData, setCountriesData] = useState([])



    const analytics = dataAnl?.analytics;
    const countries = React.useMemo(() => {
        if (!analytics?.countries?.length) return [];
        return analytics.countries.map((country: any) => ({
            ...country,
            color: getRandomColor(),
        }));
    }, [analytics?.countries]);


    useEffect(() => {
        const fetchData = async () => {
            try {
                const data = await getAnalyticsOverview(String(id));
                setNewData(data)
            } catch (error) {
                console.error(error);
            }
        };
        fetchData();
    }, [id]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const data = await getAnalyticsTimeseries(String(id));
                setTimeseries(data)
            } catch (error) {
                console.error(error);
            }
        };
        fetchData();
    }, [id]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const data = await getAnalyticsCountries(String(id));
                setCountriesData(data.countries)
            } catch (error) {
                console.error(error);
            }
        };
        fetchData();
    }, [id]);
    
    return (loading ? <Loading>
        <ProgressSpinner />
    </Loading> :
        <Content>
            <AnalyticHeader onClick={() => window.history.back()}>
                <span>Smart Links </span>
                <BackArrow color={theme.palette.text.breadcrumbs} />
                <span>Analytics</span>
            </AnalyticHeader>
            <AnalyticBar>
                <ImgBox src={data?.release?.cover_url}>
                </ImgBox>
                <InfoBox>
                    <Title>
                        <div>{data?.release.title}</div>
                        <FilterBox><SearchBox style={{ border: "1px solid", cursor: 'pointer' }} onClick={() => setOpen(!open)}>{selectedData} {!open ? <Polygon /> : <PolygonActive />}</SearchBox><span onClick={() => { setSelectedData("Last 7 Days"), setOpen(false) }} style={{ cursor: 'pointer' }}>Reset</span></FilterBox>
                    </Title>
                    {
                        open && <PeriodRangeDropdown open={open} setOpen={setOpen} setNewData={setNewData} selectedData={selectedData} setSelectedData={setSelectedData} />
                    }
                    <InfoBar>
                        <ViewsBox>
                            <span>
                                Views
                            </span>
                            <div>
                                {newData?.views || 0}
                            </div>
                        </ViewsBox>
                        <ViewsBox>
                            <span>
                                Clicks
                            </span>
                            <div>
                                {newData?.clicks || 0}
                            </div>
                        </ViewsBox>
                        <ViewsBox>
                            <span>
                                Top Country
                            </span>
                            <div>
                                {newData?.top_country || 0}
                            </div>
                        </ViewsBox>
                        <ViewsBox>
                            <span>
                                Top City
                            </span>
                            <div>
                                {newData?.top_city || 0}
                            </div>
                        </ViewsBox>
                    </InfoBar>
                </InfoBox>
            </AnalyticBar>
            <GrafikContent>
                <GrafikTitle>
                    Views & clicks
                </GrafikTitle>
                <LineChartContent
                >
                    <LineChart
                        from={timeseries?.[0]?.date || ''}
                        to={timeseries?.[timeseries.length - 1]?.date || ''}
                        timeseries={timeseries || []}
                    />
                </LineChartContent>
                <GrafikTitle>
                    Territories
                </GrafikTitle>
                <Map countries={CountriesData} />
                <CountriesBox>
                Countries
                </CountriesBox>

            </GrafikContent>
        </Content>
    );

};


const Content = styled.div`
    width:100%;
    padding:29px 26px 29px 20px;
    display:flex;
    flex-direction: column;
    gap:15px;


`

const AnalyticHeader = styled.div`
    display:flex;
    align-items: center;
    gap:7px;
    font-family: SF Pro Display;
    font-weight: 400;
    font-style: Regular;
    font-size: 15px;
    leading-trim: NONE;
    line-height: 20px;
    letter-spacing: 0%;
    vertical-align: middle;
    color:rgba(0, 0, 0, 0.5)
    cursor:pointer;
`

const AnalyticBar = styled.div`
    width:100%;
    display:flex;
    gap:15px;
`
const ImgBox = styled.img`
    width: 96px;
    height: 96px;
    border-radius: 10px;
`

const InfoBox = styled.div`
    width:100%;
    display:flex;
    flex-direction: column;
    gap:23px;

`
const Title = styled.div`
    width:100%;
    font-family: SF Pro Display;
    font-weight: 700;
    font-style: Bold;
    font-size: 16px;
    leading-trim: NONE;
    line-height: 16px;
    letter-spacing: 0%;
    vertical-align: middle;
    color:rgba(0, 0, 0, 1);
    display:flex;
    justify-content: space-between;

`
const FilterBox = styled.div`
    display:flex;
    align-items: center;
    gap:5px;
    span{
        font-family: SF Pro Display;
        font-weight: 400;
        font-style: Regular;
        font-size: 15px;
        leading-trim: NONE;
        line-height: 20px;
        letter-spacing: 0%;
        vertical-align: middle;
        color:rgba(0, 0, 0, 0.5);
    }
`
const SearchBox = styled.div`
    width: max-content;
    height: 31px;
    border-radius: 8px;
    display:flex;
    align-items: center;
    gap:5px;
    padding:5px 10px 6px 9px;
`
const InfoBar = styled.div`
    width:100%;
    display:flex;
    gap:35px;

`

const ViewsBox = styled.div`
    display:flex;
    flex-direction: column;
    gap:7px;

    span{
        font-family: SF Pro Display;
        font-weight: 500;
        font-style: Medium;
        font-size: 13px;
        leading-trim: NONE;
        line-height: 18px;
        letter-spacing: 0%;
        vertical-align: middle;
        color:rgba(0, 0, 0, 0.5);
    }
    
    div{
        font-family: Outfit;
        font-weight: 500;
        font-style: Medium;
        font-size: 30px;
        leading-trim: NONE;
        line-height: 33px;
        letter-spacing: 0%;
        vertical-align: middle;
        color:rgba(0, 0, 0, 1);

    }
`
const GrafikContent = styled.div`
    display:flex;
    flex-direction: column;
    gap:5px;
`
const GrafikTitle = styled.div`
    width:100%;
    height:39px;
    padding:10px 0 10px 20px;
    border-radius: 10px;
    background:rgba(246, 246, 246, 1);
    font-family: SF Pro Display;
    font-weight: 600;
    font-style: Semibold;
    font-size: 14px;
    leading-trim: NONE;
    line-height: 18px;
    letter-spacing: 0%;
    vertical-align: middle;
    color:rgba(0, 0, 0, 0.5);
`
const LineChartContent = styled.div`
    width: 100%;
    height: 321px;
    border-radius: 10px;

`
const MapContent = styled.div`
    width:100%;
    heigth:495px;
`
const Loading = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
`;

const CountriesBox = styled.div`
    width:100%;
    padding-bottom:16px;
    font-family: SF Pro Display;
    font-weight: 600;
    font-style: Semibold;
    font-size: 14px;
    leading-trim: NONE;
    line-height: 18px;
    letter-spacing: 0%;
    vertical-align: middle;
    color:rgba(0, 0, 0, 0.5);
    border-bottom:1px solid rgba(0, 0, 0, 0.2);
`